import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import CardBasic from '../../cards/CardBasic/CardBasic'
import SectionHeading from '../../section-heading/SectionHeading'
import { featuredProducts } from '../FeaturedProducts/featured-products.module.scss'

const ProductTypesCardSection = ({ content }) => {
  return (
    <section className={featuredProducts}>
      <Container>
        <SectionHeading title={content.title} />
        <Row>
          {content.data.map((item, index) => {
            let link = false

            content.types.map((type) => {
              if (type.title === item.title && type.url != null) {
                link = `/collections${type.url}`
              }
            })

            const image = item.image.gatsbyImageData
            return (
              <Col key={`${item.title}`} className='mb-3' lg={4}>
                <CardBasic
                  content={item}
                  shop={true}
                  url={link}
                  image={image}
                />
              </Col>
            )
          })}
        </Row>
      </Container>
    </section>
  )
}

export default ProductTypesCardSection
